import { sendPaywallTouchEvent } from '../index';
import { PaywallScreens } from '../types';
import { EventAdapter } from './EventAdapter';

export class PaywallTouchEventAdapter extends EventAdapter {
  protected intercomEventKey = 'paywall-touch';
  protected amplitudeEventFunction = sendPaywallTouchEvent;

  constructor(paywallScreen: PaywallScreens) {
    super();
    try {
      this.eventData = {
        feature_name: paywallScreen,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
